export default __webpack_public_path__ + "media/images/elements/sws-4a69a6bf72acb25bdf907074721d39f7.png";